import {
  DOCUMENT,
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

/**
 * Popups that close on Escape themselves: PrimeNG's dropdown, multiselect, autocomplete and date
 * overlays and colour picker panel, the grid view picker (`implto-grouped-select`), and AG Grid's
 * filter and column menus.
 */
const OPEN_POPUP = [
  '.p-overlay',
  '.p-colorpicker-panel:not(.p-colorpicker-panel-inline)',
  '.p-multiselect-panel.grouped-select',
  '.ag-popup .ag-popup-child',
].join(', ');

/**
 * Escape pressed while a popup is open inside a Material dialog should close only the popup. The
 * CDK hears the key on <body> and closes the dialog, discarding unsaved edits, whenever the popup
 * does not stop it first: a multiselect after a pick (focus has fallen to <body>), the colour
 * picker, the grid view picker, an AG Grid filter. Hold every open dialog for that one keystroke;
 * the popup still closes.
 */
export function provideDialogEscapeGuard(): EnvironmentProviders {
  return provideEnvironmentInitializer(() => {
    const dialog = inject(MatDialog);
    const document = inject(DOCUMENT);

    document.defaultView?.addEventListener(
      'keydown',
      (event) => {
        if (event.key !== 'Escape' || !document.querySelector(OPEN_POPUP)) {
          return;
        }
        const held = dialog.openDialogs.filter((ref) => !ref.disableClose);
        held.forEach((ref) => (ref.disableClose = true));
        setTimeout(() => held.forEach((ref) => (ref.disableClose = false)));
      },
      { capture: true },
    );
  });
}
